import { createFileRoute } from '@tanstack/react-router'
import { AdminAuthGate } from '../components/auth/admin-auth-gate'
import { AdminDashboard } from '../components/pages/AdminDashboard'

export const Route = createFileRoute('/admin')({
  component: AdminComponent,
  head: () => ({
    title: 'Admin Dashboard | AUTOGLOW Detailing',
    meta: [
      { title: 'Admin Dashboard | AUTOGLOW Detailing' },
      { name: 'robots', content: 'noindex,nofollow' },
    ],
  }),
})

function AdminComponent() {
  return (
    <AdminAuthGate>
      <AdminDashboard />
    </AdminAuthGate>
  )
}
